import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EmailsTabs, { TEMPLATES_TAB, LOGS_TAB } from './EmailsTabs';
import EmailTemplates from '../email-templates/EmailTemplates';
import EmailLogs from '../email-logs/EmailLogs';
import './_styles_/Emails.css';

function Emails() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState(TEMPLATES_TAB);
    return (
        <div className="emails">
            <h4>
                <FontAwesomeIcon icon="envelope" className="left-menu--item--icon" />
                &nbsp;{t('title.emails')}
            </h4>
            <EmailsTabs activeTab={activeTab} onTabChange={setActiveTab} />
            <div className="emails--content">
                {activeTab === TEMPLATES_TAB && <EmailTemplates />}
                {activeTab === LOGS_TAB && <EmailLogs />}
            </div>
        </div>
    );
}

export default Emails;
